import React from 'react';

import { css } from '@emotion/css';
import { Skeleton, Typography } from 'antd';
import { theme } from 'theme';

interface DailyWorkflowSummaryCardProps {
  value: number;
  label: string;
  subLabel?: string;
  loading?: boolean;
  color?: string;
}

export function DailyWorkflowSummaryCard({ value, label, subLabel, loading, color }: DailyWorkflowSummaryCardProps) {
  return (
    <div
      style={{ flex: 1 }}
      className={css`
        text-align: center;
      `}
    >
      {loading ? (
        <Skeleton.Input active size="large" style={{ width: 80, height: 48, marginBottom: 8 }} />
      ) : (
        <>
          <Typography.Title level={1} style={{ margin: 0, fontSize: 30, fontWeight: 700, color }}>
            {value.toLocaleString()}
          </Typography.Title>
          <Typography.Text style={{ fontSize: 12, color: theme.colors.neutral[600], fontWeight: 400 }}>
            {label}
            {subLabel && (
              <>
                <br />
                {subLabel}
              </>
            )}
          </Typography.Text>
        </>
      )}
    </div>
  );
}
